import { TagDataLayer } from '@axa-fr-axion/tag';
import { StepNavigationPath, TechNavigationPath } from 'interfaces';

export const DATA_LAYER_GLOBAL_MRH: Omit<TagDataLayer, 'xiti_xtpage'> = {
    page_univers: 'habitation',
    nom_site: 'devis_habitation',
    page_type: 'devis_generique',
    // INFO: This value will differ depending on the visitor.
    statut_client: 'prospect',
    code_du_produit: 'mrh',
};

export const NAVIGATION_DATA_DEVIS_MRH: Record<StepNavigationPath | TechNavigationPath, TagDataLayer | null> = {
    LogementType: {
        xiti_xtpage: 'devis_habitation::etape_1_logement::type_bien',
        nom_etape: 'etape_1_logement/type_bien',
        sollicitation: 0,
        num_etape: 1,
        page_erreur: 0,
    },
    LogementNombrePieces: {
        xiti_xtpage: 'devis_habitation::etape_1_logement::nombre_pieces',
        nom_etape: 'etape_1_logement/nombre_pieces',
        sollicitation: 0,
        num_etape: 1,
        page_erreur: 0,
    },
    LocataireType: {
        xiti_xtpage: 'devis_habitation::etape_1_logement::locataire_proprietaire',
        nom_etape: 'etape_1_logement/locataire_proprietaire',
        sollicitation: 0,
        num_etape: 1,
        page_erreur: 0,
    },
    LogementResidencePrincipale: {
        xiti_xtpage: 'devis_habitation::etape_1_logement::residence_principale',
        nom_etape: 'etape_1_logement/residence_principale',
        sollicitation: 0,
        num_etape: 1,
        page_erreur: 0,
    },
    LogementAdresse: {
        xiti_xtpage: 'devis_habitation::etape_1_logement::adresse_bien',
        nom_etape: 'etape_1_logement/adresse_bien',
        sollicitation: 0,
        num_etape: 1,
        page_erreur: 0,
    },
    LogementDebutAssurance: {
        xiti_xtpage: 'devis_habitation::etape_1_logement::debut_contrat',
        nom_etape: 'etape_1_logement/debut_contrat',
        sollicitation: 0,
        num_etape: 1,
        page_erreur: 0,
    },
    PreContact: null,
    Contact: {
        xiti_xtpage: 'devis_habitation::etape_2_coordonnees::coordonnees',
        nom_etape: 'etape_2_coordonnees/coordonnees',
        sollicitation: 0,
        num_etape: 2,
        page_erreur: 0,
    },
    PreChooseAdvisor: null,
    ChooseAdvisor: {
        xiti_xtpage: 'devis_habitation::etape_2_coordonnees::choix_agent',
        nom_etape: 'etape_2_coordonnees/choix_agent',
        sollicitation: 0,
        num_etape: 2,
        page_erreur: 0,
    },
    PreConfirmation: null,
    Error: {
        xiti_xtpage: 'devis_habitation::etape_3_confirmation::ko::erreur_technique',
        nom_etape: 'etape_3_confirmation/ko/erreur_technique',
        sollicitation: 0,
        num_etape: 3,
        page_erreur: 1,
    },
    Scenarios: null,
    'End/Confirmation': {
        xiti_xtpage: 'devis_habitation::etape_3_confirmation::ok::agent',
        nom_etape: 'etape_3_confirmation/ok/agent',
        sollicitation: 1,
        num_etape: 3,
        page_erreur: 0,
    },
    'End/AxaPartner': {
        xiti_xtpage: 'devis_habitation::etape_3_confirmation::ok::axa_part',
        nom_etape: 'etape_3_confirmation/ok/axa_part',
        sollicitation: 1,
        num_etape: 3,
        page_erreur: 0,
    },
    'End/Reject': {
        xiti_xtpage: 'devis_habitation::etape_3_confirmation::ko::rejet',
        nom_etape: 'etape_3_confirmation/ko/rejet',
        sollicitation: 0,
        num_etape: 3,
        page_erreur: 1,
        rejet: 'rejet',
    },
    'End/Unreliable-contact-information': {
        xiti_xtpage: 'devis_habitation::etape_3_confirmation::ko::cnf',
        nom_etape: 'etape_3_confirmation/ko/cnf',
        sollicitation: 0,
        num_etape: 3,
        page_erreur: 1,
        rejet: 'cnf',
    },
    'End/Apart-from-metropolis': {
        xiti_xtpage: 'devis_habitation::etape_3_confirmation::ko::dom_tom',
        nom_etape: 'etape_3_confirmation/ko/dom_tom',
        sollicitation: 0,
        num_etape: 3,
        page_erreur: 1,
        rejet: 'hors_metropole',
    },
    'End/Out-of-bounds': {
        xiti_xtpage: 'devis_habitation::etape_3_confirmation::ko::hors_limite',
        nom_etape: 'etape_3_confirmation/ko/hors_limite',
        sollicitation: 0,
        num_etape: 3,
        page_erreur: 1,
        rejet: 'hors_limite',
    },
    'End/Insurance': {
        xiti_xtpage: 'devis_habitation::etape_3_confirmation::ko::assurance',
        nom_etape: 'etape_3_confirmation/ko/assurance',
        sollicitation: 0,
        num_etape: 3,
        page_erreur: 1,
        rejet: 'assurance',
    },
    'End/Sollicitation': {
        xiti_xtpage: 'devis_habitation::etape_3_confirmation::ko::sollicitation',
        nom_etape: 'etape_3_confirmation/ko/sollicitation',
        sollicitation: 0,
        num_etape: 3,
        page_erreur: 1,
        rejet: 'sollicitation',
    },
    'End/Off-target-product': {
        xiti_xtpage: 'devis_habitation::etape_3_confirmation::ko::hors_cible_produit',
        nom_etape: 'etape_3_confirmation/ko/hors_cible_produit',
        sollicitation: 0,
        num_etape: 3,
        page_erreur: 1,
        rejet: 'hors_cible_produit',
    },
    'End/Csi': {
        xiti_xtpage: 'devis_habitation::etape_3_confirmation::ok::csi',
        nom_etape: 'etape_3_confirmation/ok/csi',
        sollicitation: 1,
        num_etape: 3,
        page_erreur: 0,
    },
    'End/Banque': null,
};
